export const deliveryCostValue = ({ amount, freeShippingPrice, hasShippingBar, translations }) => {
  const [freeValue, paidValue] = (translations?.cart?.deliveryCostsValue || '').split('|');
  const isFree = Boolean(hasShippingBar) && Number(amount) > Number(freeShippingPrice);
  return {
    isFree,
    value: isFree
      ? freeValue || translations?.cart?.freeShipping
      : paidValue || translations?.cart?.shippingCostsMessage,
  };
};

export default deliveryCostValue;
